// ===============================================
// CONFIG: selectors (adjust if IDs ever change)
// ===============================================
const APPSTLE_WIDGET_SELECTOR = '.appstle_sub_widget';
const APPSTLE_PLAN_WRAPPER_SELECTOR = '.appstleRadioSellingPlanWrapper';
const STICKY_SELECTOR_ID = 'stickyVariantSelector';
const STICKY_OPTION_SELECTOR = '.sticky-variant-option';
const PROMO_BADGE_SELECTOR = '.custom-promo-badge-wrapper .custom-promo-badge';
const ATC_BUTTON_SELECTOR = '.custom-main-product-atc-wrapper .custom-main-product-atc-button';

let appstleRoot = null;

// ===============================================
// URL DETECTION HELPER
// ===============================================
function getCurrentProductUrl() {
  return window.location.pathname;
}

function isOriginalProduct() {
  return getCurrentProductUrl().includes('/products/creatinecoffee-o4');
}

function isMorningUpgradeProduct() {
  return getCurrentProductUrl().includes('/products/creatinecoffee-o5');
}

// ===============================================
// CUSTOM SELLING PLAN TEXT REPLACEMENT - ORIGINAL PRODUCT
// ===============================================
function replaceSellingPlanText(root = document) {
  const container = root.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR) || 
                    document.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR);
  
  if (!container) return;

  const wrappers = container.querySelectorAll('.appstle-radio-wrapper');
  if (wrappers.length < 2) return;

  // FIRST PLAN: 90-Day Supply (Every 12 weeks)
  const firstWrapper = wrappers[0];
  const firstLabel = firstWrapper.querySelector('label');
  const firstSellingPlan = firstLabel?.querySelector('.sellingplan');
  
  if (firstSellingPlan && !firstSellingPlan.dataset.customReplaced) {
    firstSellingPlan.dataset.customReplaced = 'true';
    firstSellingPlan.innerHTML = `
      90-Day Supply 
      <span class="appstle-subscription-plans-discounts appstle-subscription-discounts-highlighter">(Save 34%)</span> 
      <span class="appstle-subscription-plans-pricings appstle-subscription-highlighter">$78 <sup class="appstle-subscription-strike-through">$119</sup> /mo</span>
    `.trim();
  }

  // SECOND PLAN: 30-Day Supply (Every 4 weeks)
  const secondWrapper = wrappers[1];
  const secondLabel = secondWrapper.querySelector('label');
  const secondSellingPlan = secondLabel?.querySelector('.sellingplan');
  
  if (secondSellingPlan && !secondSellingPlan.dataset.customReplaced) {
    secondSellingPlan.dataset.customReplaced = 'true';
    secondSellingPlan.innerHTML = `
      30-Day Supply 
      <span class="appstle-subscription-plans-discounts">(Save 25%)</span> 
      <span class="appstle-subscription-plans-pricings">$89 <sup class="appstle-subscription-strike-through">$119</sup> /mo</span>
    `.trim();
  }
}

// ===============================================
// CUSTOM SELLING PLAN TEXT REPLACEMENT - MORNING UPGRADE PRODUCT
// ===============================================
function replaceSellingPlanTextMorningUpgrade(root = document) {
  const container = root.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR) || 
                    document.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR);
  
  if (!container) return;

  const wrappers = container.querySelectorAll('.appstle-radio-wrapper');
  if (wrappers.length < 2) return;

  // FIRST PLAN: 90-Day Supply (Every 12 weeks) - Morning Upgrade Pricing
  const firstWrapper = wrappers[0];
  const firstLabel = firstWrapper.querySelector('label');
  const firstSellingPlan = firstLabel?.querySelector('.sellingplan');
  
  if (firstSellingPlan && !firstSellingPlan.dataset.customReplaced) {
    firstSellingPlan.dataset.customReplaced = 'true';
    firstSellingPlan.innerHTML = `
      90-Day Supply 
      <span class="appstle-subscription-plans-discounts appstle-subscription-discounts-highlighter">(Save 41%)</span> 
      <span class="appstle-subscription-plans-pricings appstle-subscription-highlighter">$58 <sup class="appstle-subscription-strike-through">$99</sup> /mo</span>
    `.trim();
  }

  // SECOND PLAN: 30-Day Supply (Every 4 weeks) - Morning Upgrade Pricing
  const secondWrapper = wrappers[1];
  const secondLabel = secondWrapper.querySelector('label');
  const secondSellingPlan = secondLabel?.querySelector('.sellingplan');
  
  if (secondSellingPlan && !secondSellingPlan.dataset.customReplaced) {
    secondSellingPlan.dataset.customReplaced = 'true';
    secondSellingPlan.innerHTML = `
      30-Day Supply 
      <span class="appstle-subscription-plans-discounts">(Save 21%)</span> 
      <span class="appstle-subscription-plans-pricings">$78 <sup class="appstle-subscription-strike-through">$99</sup> /mo</span>
    `.trim();
  }
}

// ===============================================
// MASTER FUNCTION - ROUTE TO CORRECT VERSION
// ===============================================
function replaceSellingPlanTextRouter(root = document) {
  if (isMorningUpgradeProduct()) {
    replaceSellingPlanTextMorningUpgrade(root);
  } else if (isOriginalProduct()) {
    replaceSellingPlanText(root);
  }
}

// ===============================================
// 1) DECORATE .sellingplan SPANS
// ===============================================
function decorateSellingPlans(root = document) {
  const sellingPlans = root.querySelectorAll('.sellingplan');
  if (!sellingPlans.length) return;

  sellingPlans.forEach((span, index) => {
    // Avoid re-processing if already wrapped
    if (span.querySelector('.appstle-subscription-plans-pricings')) return;

    const text = span.textContent.trim();
    
    // Match patterns for discount like "(Save 37%)"
    const discountMatch = text.match(/(\(Save\s+\d+%\))/);
    
    // Match TWO price patterns: $78 and $119 /mo
    const doublePriceMatch = text.match(/(\$\d+)\s+(\$\d+)\s+(\/mo)/);
    
    // Match single price pattern: $78 /mo (fallback if no double price)
    const singlePriceMatch = text.match(/(\$\d+\s*\/mo)/);

    if (discountMatch || doublePriceMatch || singlePriceMatch) {
      let newHTML = text;
      
      // Handle the discount text first
      if (discountMatch) {
        const discountText = discountMatch[1];
        const discountClassList =
          index === 0
            ? 'appstle-subscription-plans-discounts appstle-subscription-discounts-highlighter'
            : 'appstle-subscription-plans-discounts';
        
        newHTML = newHTML.replace(
          discountText,
          `<span class="${discountClassList}">${discountText}</span>`
        );
      }
      
      // Handle DOUBLE price pattern (e.g., $78 $119 /mo)
      if (doublePriceMatch) {
        const firstPrice = doublePriceMatch[1];    // $78
        const secondPrice = doublePriceMatch[2];   // $119
        const frequency = doublePriceMatch[3];     // /mo
        const fullPriceText = `${firstPrice} ${secondPrice} ${frequency}`;
        
        const priceClassList =
          index === 0
            ? 'appstle-subscription-plans-pricings appstle-subscription-highlighter'
            : 'appstle-subscription-plans-pricings';
        
        // Create the new structure with strike-through
        const wrappedPrice = `<span class="${priceClassList}">${firstPrice} <sup class="appstle-subscription-strike-through">${secondPrice}</sup> ${frequency}</span>`;
        
        newHTML = newHTML.replace(fullPriceText, wrappedPrice);
      }
      // Handle SINGLE price pattern (fallback)
      else if (singlePriceMatch) {
        const priceText = singlePriceMatch[1];
        const priceClassList =
          index === 0
            ? 'appstle-subscription-plans-pricings appstle-subscription-highlighter'
            : 'appstle-subscription-plans-pricings';
        
        newHTML = newHTML.replace(
          priceText,
          `<span class="${priceClassList}">${priceText}</span>`
        );
      }
      
      span.innerHTML = newHTML;
    }
  });
}

// ===============================================
// 2) CLICK ENTIRE .appstle-radio-wrapper
// ===============================================
function initAppstleRadioWrappers(root = document) {
  const wrappers = root.querySelectorAll('.appstle-radio-wrapper');
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    // Avoid double-binding
    if (wrapper.dataset.appstleWrapperBound === 'true') return;
    wrapper.dataset.appstleWrapperBound = 'true';

    wrapper.addEventListener('click', function (event) {
      // If user clicks directly on the radio, let default behavior work
      if (
        event.target.tagName.toLowerCase() === 'input' &&
        event.target.type === 'radio'
      ) {
        return;
      }

      const radio = wrapper.querySelector('input[type="radio"]');
      if (!radio) return;

      // Check this radio
      radio.checked = true;

      // Fire change event so Appstle / theme logic responds
      const changeEvent = new Event('change', { bubbles: true });
      radio.dispatchEvent(changeEvent);
    });
  });
}

// ===============================================
// 3) SHOW/HIDE PROMO BADGE BASED ON PLAN
// ===============================================
function updatePromoBadgeVisibility(root = document) {
  const container = root.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR) || document.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR);
  const promoBadge = document.querySelector(PROMO_BADGE_SELECTOR);

  if (!container || !promoBadge) return;

  const wrappers = container.querySelectorAll('.appstle-radio-wrapper');
  if (wrappers.length < 2) return;

  const firstWrapper = wrappers[0];
  const secondWrapper = wrappers[1];

  const firstRadio = firstWrapper.querySelector('input[type="radio"]');
  const secondRadio = secondWrapper.querySelector('input[type="radio"]');

  if (!firstRadio || !secondRadio) return;

  if (firstRadio.checked) {
    promoBadge.classList.remove('custom-promo-hidden');
  } else if (secondRadio.checked) {
    promoBadge.classList.add('custom-promo-hidden');
  }
}

function wirePromoBadgeToggle(root = document) {
  const container = root.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR) || document.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR);
  if (!container) return;

  const radios = container.querySelectorAll('input[type="radio"]');
  radios.forEach((radio) => {
    if (radio.dataset.promoBadgeBound === 'true') return;
    radio.dataset.promoBadgeBound = 'true';

    radio.addEventListener('change', function () {
      updatePromoBadgeVisibility();
    });
  });

  updatePromoBadgeVisibility();
}

// ===============================================
// 4) TWO-WAY SYNC: APPSTLE FIRST/SECOND PLAN ↔ STICKY FIRST/SECOND OPTION
// ===============================================
function selectStickyOptionSilently(option) {
  if (!option) return;

  const stickyMainEl = document.getElementById('stickyVariantMain');
  const stickySubEl = document.getElementById('stickyVariantSub');
  const stickySelector = document.getElementById(STICKY_SELECTOR_ID);

  if (!stickyMainEl || !stickySubEl || !stickySelector) return;

  const variantId = option.getAttribute('data-variant-id');
  const mainText = option.getAttribute('data-main');
  const subText = option.getAttribute('data-sub');

  // Update visible text
  if (mainText) stickyMainEl.textContent = mainText;
  if (subText) stickySubEl.textContent = subText;

  // Update global variant ID
  if (variantId) {
    window.customMainProductCurrentVariantId = parseInt(variantId, 10);
    stickySelector.setAttribute('data-selected-id', variantId);
  }

  // Close dropdown
  stickySelector.classList.remove('open');
}

function selectAppstleWrapperSilently(wrapper) {
  if (!wrapper) return;

  const radio = wrapper.querySelector('input[type="radio"]');
  if (!radio || radio.checked) return;

  wrapper.dataset.programmaticClick = 'true';
  wrapper.click();
  setTimeout(() => {
    delete wrapper.dataset.programmaticClick;
  }, 100);
}

function syncAppstleToStickyOption(root = document) {
  const container = root.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR) || document.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR);
  const stickyOptions = document.querySelectorAll(STICKY_OPTION_SELECTOR);

  if (!container || stickyOptions.length < 2) return;

  const wrappers = container.querySelectorAll('.appstle-radio-wrapper');
  if (wrappers.length < 2) return;

  const firstAppstleRadio = wrappers[0].querySelector('input[type="radio"]');
  const secondAppstleRadio = wrappers[1].querySelector('input[type="radio"]');

  const firstStickyOption = stickyOptions[0];
  const secondStickyOption = stickyOptions[1];

  if (!firstAppstleRadio || !secondAppstleRadio) return;

  if (firstAppstleRadio.checked) {
    selectStickyOptionSilently(firstStickyOption);
  } else if (secondAppstleRadio.checked) {
    selectStickyOptionSilently(secondStickyOption);
  }
}

function syncStickyToAppstlePlan(clickedOption, root = document) {
  const container = root.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR) || document.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR);
  const stickyOptions = document.querySelectorAll(STICKY_OPTION_SELECTOR);

  if (!container || stickyOptions.length < 2) return;

  const wrappers = container.querySelectorAll('.appstle-radio-wrapper');
  if (wrappers.length < 2) return;

  const firstStickyOption = stickyOptions[0];
  const secondStickyOption = stickyOptions[1];

  const firstAppstleWrapper = wrappers[0];
  const secondAppstleWrapper = wrappers[1];

  if (clickedOption === firstStickyOption) {
    selectAppstleWrapperSilently(firstAppstleWrapper);
  } else if (clickedOption === secondStickyOption) {
    selectAppstleWrapperSilently(secondAppstleWrapper);
  }
}

function wireAppstleToStickySync(root = document) {
  const container = root.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR) || document.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR);
  if (!container) return;

  const radios = container.querySelectorAll('input[type="radio"]');

  radios.forEach((radio) => {
    if (radio.dataset.stickyTwoWayBound === 'true') return;
    radio.dataset.stickyTwoWayBound = 'true';

    radio.addEventListener('change', function () {
      const wrapper = radio.closest('.appstle-radio-wrapper');
      if (wrapper && wrapper.dataset.programmaticClick === 'true') return;
      syncAppstleToStickyOption();
    });
  });

  syncAppstleToStickyOption();
}

function wireStickyToAppstleSync() {
  const stickyOptions = document.querySelectorAll(STICKY_OPTION_SELECTOR);

  stickyOptions.forEach((option) => {
    if (option.dataset.appstleTwoWayBound === 'true') return;
    option.dataset.appstleTwoWayBound = 'true';

    option.addEventListener('click', function (event) {
      event.stopPropagation();
      syncStickyToAppstlePlan(option);
    });
  });
}

// ===============================================
// 5) OPTIONAL: APPEND PRICE TO MAIN ATC BUTTON
// ===============================================
function updateAtcButtonWithPrice(root = document) {
  const container = root.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR) || document.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR);
  const atcButton = document.querySelector(ATC_BUTTON_SELECTOR);

  if (!container || !atcButton) return;

  const wrappers = container.querySelectorAll('.appstle-radio-wrapper');
  if (wrappers.length < 2) return;

  const firstWrapper = wrappers[0];
  const secondWrapper = wrappers[1];

  const firstRadio = firstWrapper.querySelector('input[type="radio"]');
  const secondRadio = secondWrapper.querySelector('input[type="radio"]');

  if (!firstRadio || !secondRadio) return;

  let selectedWrapper = null;

  if (firstRadio.checked) {
    selectedWrapper = firstWrapper;
  } else if (secondRadio.checked) {
    selectedWrapper = secondWrapper;
  }

  let priceText = '';
  if (selectedWrapper) {
    const priceSpan = selectedWrapper.querySelector('.appstle-subscription-plans-pricings');
    if (priceSpan) priceText = priceSpan.textContent.trim();
  }

  const baseText = atcButton.getAttribute('data-default-text') || 'ADD TO CART';
  const buttonTextSpan = atcButton.querySelector('.custom-atc-button-text');

  if (buttonTextSpan) {
    if (priceText) {
      buttonTextSpan.textContent = baseText + ' - ' + priceText;
    } else {
      buttonTextSpan.textContent = baseText;
    }
  }
}

function wireAtcButtonPriceUpdate(root = document) {
  const container = root.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR) || document.querySelector(APPSTLE_PLAN_WRAPPER_SELECTOR);
  if (!container) return;

  const radios = container.querySelectorAll('input[type="radio"]');

  radios.forEach((radio) => {
    if (radio.dataset.atcPriceBound === 'true') return;
    radio.dataset.atcPriceBound = 'true';

    radio.addEventListener('change', function () {
      updateAtcButtonWithPrice();
    });
  });

  updateAtcButtonWithPrice();
}

// ===============================================
// 6) INITIALIZE ALL BEHAVIOURS ONCE APPSTLE READY
// ===============================================
function initAllAppstleEnhancements(root = document) {
  replaceSellingPlanTextRouter(root);
  // decorateSellingPlans(root);
  initAppstleRadioWrappers(root);
  wirePromoBadgeToggle(root);
  wireAppstleToStickySync(root);
  wireStickyToAppstleSync();
  // wireAtcButtonPriceUpdate(root);
}

// Poll for Appstle widget root once
(function waitForAppstleRoot() {
  const intervalId = setInterval(() => {
    appstleRoot = document.querySelector(APPSTLE_WIDGET_SELECTOR);
    const hasSticky = document.getElementById(STICKY_SELECTOR_ID);

    if (appstleRoot && hasSticky) {
      initAllAppstleEnhancements(appstleRoot);

      // Scoped MutationObserver: only watch the Appstle widget for changes
      const scopedObserver = new MutationObserver((mutations) => {
        // Use a micro-throttle: run once per batch
        let shouldRun = false;
        for (const m of mutations) {
          if (m.addedNodes && m.addedNodes.length) {
            shouldRun = true;
            break;
          }
        }
        if (!shouldRun) return;

        initAllAppstleEnhancements(appstleRoot);
      });

      scopedObserver.observe(appstleRoot, {
        childList: true,
        subtree: true,
      });

      clearInterval(intervalId);
    }
  }, 200);
})();

// ------------------------------------------------------------------------------------------------

// =======================================================
// CPCS – ISOLATED LINK BETWEEN SECTION DROPDOWN & APPSTLE
// (for cpcsVariantSelector only – does NOT touch sticky bar)
// =======================================================

(function CPCS_AppstleLinker() {
  const CPCS_SELECTOR_ID      = 'cpcsVariantSelector';
  const CPCS_OPTION_SELECTOR  = '.cpcs-sticky-variant-option';
  const CPCS_MAIN_TEXT_ID     = 'cpcsVariantMain';
  const CPCS_SUB_TEXT_ID      = 'cpcsVariantSub';

  const CPCS_APPSTLE_WIDGET_SEL = '.appstle_sub_widget';
  const CPCS_PLAN_WRAPPER_SEL   = '.appstleRadioSellingPlanWrapper';

  function cpcsIsoGetAppstleWrappers(root) {
    const scope = root || document;
    const container =
      scope.querySelector(CPCS_PLAN_WRAPPER_SEL) ||
      document.querySelector(CPCS_PLAN_WRAPPER_SEL);

    if (!container) return null;

    const wrappers = container.querySelectorAll('.appstle-radio-wrapper');
    if (wrappers.length < 2) return null;

    const firstWrapper  = wrappers[0];
    const secondWrapper = wrappers[1];
    const firstRadio    = firstWrapper.querySelector('input[type="radio"]');
    const secondRadio   = secondWrapper.querySelector('input[type="radio"]');

    if (!firstRadio || !secondRadio) return null;

    return {
      container,
      wrappers,
      firstWrapper,
      secondWrapper,
      firstRadio,
      secondRadio
    };
  }

  function cpcsIsoSelectAppstleWrapperSilently(wrapper) {
    if (!wrapper) return;

    const radio = wrapper.querySelector('input[type="radio"]');
    if (!radio || radio.checked) return;

    wrapper.dataset.cpcsIsoProgrammaticClick = 'true';
    wrapper.click();
    setTimeout(() => {
      delete wrapper.dataset.cpcsIsoProgrammaticClick;
    }, 120);
  }

  function cpcsIsoSyncAppstleToCpcs(root) {
    const appstle = cpcsIsoGetAppstleWrappers(root);
    if (!appstle) return;

    const { firstRadio, secondRadio } = appstle;
    const selector = document.getElementById(CPCS_SELECTOR_ID);
    const mainEl   = document.getElementById(CPCS_MAIN_TEXT_ID);
    const subEl    = document.getElementById(CPCS_SUB_TEXT_ID);
    const options  = document.querySelectorAll(CPCS_OPTION_SELECTOR);

    if (!selector || !mainEl || !subEl || options.length < 2) return;

    let targetOption = null;

    if (firstRadio.checked) {
      targetOption = options[0];
    } else if (secondRadio.checked) {
      targetOption = options[1];
    } else {
      return;
    }

    const variantId = targetOption.getAttribute('data-variant-id');
    const mainText  = targetOption.getAttribute('data-main');
    const subText   = targetOption.getAttribute('data-sub');

    if (mainText) mainEl.textContent = mainText;
    if (subText)  subEl.textContent  = subText;

    if (variantId) {
      window.customMainProductCurrentVariantId = parseInt(variantId, 10);
      selector.setAttribute('data-selected-id', variantId);
    }

    selector.classList.remove('open');
  }

  // Exposed ONLY for the comparison section
  window.cpcsSyncDropdownToAppstle = function(clickedOption) {
    const appstle = cpcsIsoGetAppstleWrappers();
    if (!appstle) return;

    const { firstWrapper, secondWrapper } = appstle;
    const options = document.querySelectorAll(CPCS_OPTION_SELECTOR);
    if (options.length < 2) return;

    const firstOption  = options[0];
    const secondOption = options[1];

    if (clickedOption === firstOption) {
      cpcsIsoSelectAppstleWrapperSilently(firstWrapper);
    } else if (clickedOption === secondOption) {
      cpcsIsoSelectAppstleWrapperSilently(secondWrapper);
    }
  };

  function cpcsIsoWireAppstleToCpcs(root) {
    const appstle = cpcsIsoGetAppstleWrappers(root);
    if (!appstle) return;

    replaceSellingPlanTextRouter(root);

    const { container } = appstle;
    const radios = container.querySelectorAll('input[type="radio"]');

    radios.forEach((radio) => {
      if (radio.dataset.cpcsIsoBound === 'true') return;
      radio.dataset.cpcsIsoBound = 'true';

      radio.addEventListener('change', function () {
        const wrapper = radio.closest('.appstle-radio-wrapper');
        if (wrapper && wrapper.dataset.cpcsIsoProgrammaticClick === 'true') {
          return;
        }
        cpcsIsoSyncAppstleToCpcs(root);
      });
    });

    cpcsIsoSyncAppstleToCpcs(root);
  }

  (function cpcsIsoPollForAppstle() {
    const pollId = setInterval(() => {
      const appstleRoot = document.querySelector(CPCS_APPSTLE_WIDGET_SEL);
      const cpcsSelector = document.getElementById(CPCS_SELECTOR_ID);

      if (appstleRoot && cpcsSelector) {
        cpcsIsoWireAppstleToCpcs(appstleRoot);

        const observer = new MutationObserver((mutations) => {
          let changed = false;
          for (const m of mutations) {
            if (m.addedNodes && m.addedNodes.length) {
              changed = true;
              break;
            }
          }
          if (!changed) return;
          cpcsIsoWireAppstleToCpcs(appstleRoot);
        });

        observer.observe(appstleRoot, {
          childList: true,
          subtree: true
        });

        clearInterval(pollId);
      }
    }, 200);
  })();
})();
